// Full-document render of the embeddable footer-only iframe page
// (/cms/frameutils/footer/): the standard document shell with the header
// slot suppressed -- and with it the flash-messages block, which lived in
// the legacy header include (messages={false}; the server side skips the
// queue drain via include_messages=False to match) -- plus the
// iframe-resizer contentWindow script the legacy template added.
import React from "react";

import { Context, templates } from "@reactivated";

import { PageSkeleton } from "../components/PageSkeleton";

// Mutable reactivated props (not Immutable<>): this template composes
// PageSkeleton, which is typed with mutable reactivated props (see
// PageSkeleton).
export const Template = (
    props: templates.FooterIFrameDocumentTemplate,
): React.JSX.Element => {
    const staticBase = React.useContext(Context).chrome.static_base;
    return (
        <PageSkeleton
            pageChrome={props.page_chrome}
            header={false}
            messages={false}
        >
            <script
                src={`${staticBase}dist2/iframe-resizer/iframeResizer.contentWindow.js`}
            />
        </PageSkeleton>
    );
};
